import React from 'react';

import { Container } from './styles';

const Separator = (props) => <Container {...props} />;

Separator.propTypes = {};

export { Separator };
